<template>
  <div class="pfslide">
    <div class="pfslide__title pfslide__title_smspace" v-html="title"></div>
    <div class="pfslide__smtitle" v-html="`Код отправлен на номер <span style='white-space:nowrap'>${client?.tel}</span>`"></div>
    <div class="pfslide__thincontent popform__hidable">
      <NumberInput 
              text='Введите код из SMS'
              name='code'
              mask='####'
              :filled="(v)=>v.length==4"
              :validation="codeValidation"
              :modelValue="code"
              @update:modelValue="set"/>
      <div class="sendagainwrapper">
        <button class="sendagainbutton" @click.stop.prevent="sendAgain" :class="{'sendagainbutton_active': (!loading) && again, 'sendagainbutton_hidden': (timer < 0)}">
          <span v-if="again && (timer >= 0)">Отправить ещё раз</span>
          <span v-if="!again && (timer >=0)">
            Повторная отправка доступна через <span style="font-weight: 500">{{(''+Math.floor(timer / 60)).padStart(2,0)}}:{{(''+(60 - timer) % 60).padStart(2,0)}}</span>{{'\xa0'}}
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapState } from 'vuex'
import slide from '../../mixins/slide.vue'
  import NumberInput from '../inputs/NumberInput.vue'
  export default {
    name: "slide7",
    mixins: [slide],
    props: {
      timer: {type: Number, default: 0}
    },
    components: { NumberInput },
    computed: {
      ...mapState(['code','client']),
      ...mapGetters(['loading']),
      again(){
        return this.timer >= 60
      },
    },
    methods: {
      set(v){
        this.$store.commit('setCode', v)
      },
      async codeValidation(v){
        if (v.length < 4) return '4 символа'
        return ''
      },
      sendAgain(e){
        if (!e.isTrusted)
          return
        if (this.loading) return
        if (this.timer >= 60)
          this.$emit('sendAgain')
        else {
          if (this.timer >= 0) 
            alert('Повторная отправка доступна через ' + (60 - this.timer) + 'сек.')
          else
            alert('Превышено кол-во попыток')
        }
      }
    },
}
</script>

<style lang="sass" scoped>
.pfslide__smtitle-mobhidden
  @include for-mob
    visibility: hidden
    height: 44px
    overflow: hidden
    margin-bottom: 0
.sendagainwrapper
  padding-top: 5px
  margin-bottom: 0
  margin-bottom: 32px
.sendagainbutton
  pointer-events: none
  text-align: center
  border: none
  transition: opacity .3s ease-out
  font-size: 18px
  line-height: 1.12
  color: colors.$bluefont2
  letter-spacing: globalvars.$onespacing
  font-variant-numeric: tabular-nums
  
  &_active
    cursor: pointer
    text-decoration: underline
    font-weight: 500
    color: colors.$newred
    pointer-events: auto
  &_hidden
    opacity: 0
    pointer-events: none
</style>